export default (url, options) => {
  if(location.protocol === 'https:') {
    url = (url || '').replace(/^(https*\:\/\/)/gi, location.protocol + '//');
  }
  return url;
};
